import React from "react"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"

export default function ToolbarListButton(state: any, props: any) {
    const {blockType, options} = props.menuParams

    let option: any
    _.some(options, o=>{
        if (o.options) {
            option = _.find(o.options, option=>option.value === blockType)
        } else if (o.value === blockType) {
            option = o
        }

        return !!option
    })

    const isSelected = !!option
    if (!option) option = _.find(options, o=>o.value === 'bullet')

    const classes = Classes("flex-row-center-center", {
        'show-popover': state.showPopover
    })

    return (
        <ControlButtonStandard className={classes} isSelected={isSelected}>
            {option.icon && <div className={Classes("ui5-ico-16", option.icon, {'selected': isSelected})}/>}
        </ControlButtonStandard>
    )
}